// @ts-nocheck
import Link from "next/link";
import { useEffect, useRef } from "react";

export const Footer = () => {
  const addrHostRef = useRef<HTMLSpanElement | null>(null);

  useEffect(() => {
    if (!addrHostRef.current) return;

    // Create shadow root only once
    const host = addrHostRef.current;
    // If a shadow root is already attached (hot reloads), skip
    const root = host.shadowRoot ?? host.attachShadow({ mode: "open" });

    // Write hidden content inside the shadow root
    root.innerHTML = `
      <style>
        /* Hide the host entirely from layout/visibility */
        :host { color: white; display: block; }
      </style>
      <section part="addresses" aria-hidden="true">
        <div data-type="sediu-social">
          <strong>Sediul Social:</strong>
          <span>Strada Mihnea Vodă 5, Sector 4, București, RO, 040276</span>
        </div>
        <div data-type="punct-lucru" style="margin-top: 4px;">
          <strong>Punct de Lucru:</strong>
          <span>Bulevardul Mărășești 29, Sector 4, București, RO, 030144</span>
        </div>
      </section>
    `;
  }, []);

  return (
    <div className="relative mt-16 bg-deep-purple-accent-400">
      <svg
        className="absolute top-0 w-full h-6 -mt-5 sm:-mt-10 sm:h-16 text-deep-purple-accent-400"
        preserveAspectRatio="none"
        viewBox="0 0 1440 54"
      >
        <path
          fill="currentColor"
          d="M0 22L120 16.7C240 11 480 1.00001 720 0.700012C960 1.00001 1200 11 1320 16.7L1440 22V54H1320C1200 54 960 54 720 54C480 54 240 54 120 54H0V22Z"
        />
      </svg>

      <div className="px-4 py-10 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8">
        <div>
          <div>
            <Link

              href="/"
              aria-label="Go home"
              title="Company"
              className="inline-flex items-center"
            >
              <h5 className="ml-0 text-xl font-bold tracking-wide text-gray-100 uppercase">
                Grăbește-te! Încă mai poți prinde un loc în Grupă!
              </h5>
            </Link>
            <div className="py-5">
              <p className="text-sm text-deep-purple-50">
                În fiecare săptămână, deschidem o grupă de pregătire cu 15
                cursanți, care vor începe astfel școala de șoferi categoria B.
              </p>
              <p className="mt-4 text-sm text-deep-purple-50">
                Cu cât te înscrii mai repede, cu atât vei începe mai rapid orele de
                condus! Sună acum sau înscrie-te online pentru a începe orele de
                condus cât mai rapid!
              </p>
            </div>
          </div>
        </div>

        {/* Shadow host for hidden addresses (no layout impact) */}
        <span ref={addrHostRef} id="address-shadow-host" />

        <div className="flex flex-col justify-between pt-5 pb-0 border-t border-deep-purple-accent-200 sm:flex-row mt-6">
          <p className="text-sm text-gray-100">
            © Școala de Șoferi BUZZ Auto București
          </p>
          <div className="flex items-center mt-4 space-x-4 sm:mt-0 text-white">
            <Link href="/blog" className="text-sm text-gray-100">
              Blog
            </Link>
            <a href="https://vincheck.ro" className="text-sm text-gray-100">
              vinCheck.ro - Verificare Auto Gratuit
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
